export interface ProsodyValues {
  volume: string;
  rate: string;
  duration: string;
  pitch: string;
  contour: string;
}

export const defaultProsodyValues: ProsodyValues = {
  volume: "",
  rate: "",
  duration: "",
  pitch: "",
  contour: "",
};
